import React, { useState } from 'react';
import Header from '../../components/Header';
import Icon from '../../components/AppIcon';
import Button from '../../components/ui/Button';
import Input from '../../components/ui/Input';
import Select from '../../components/ui/Select';
import CourseCard from './components/CourseCard';
import SkillPathCard from './components/SkillPathCard';
import AchievementBadge from './components/AchievementBadge';
import SkillAssessmentCard from './components/SkillAssessmentCard';
import CertificationCard from './components/CertificationCard';
import LearningResourceCard from './components/LearningResourceCard';
import StudyGroupCard from './components/StudyGroupCard';

const SkillsDevelopmentAcademy = () => {
  const [activeTab, setActiveTab] = useState('courses');
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [selectedLevel, setSelectedLevel] = useState('all');

  const courses = [
    {
      id: 1,
      title: "Nonprofit Leadership Fundamentals",
      description: "Master the essential skills needed to lead nonprofit organizations effectively, from strategic planning to team management.",
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_171170bd3-1764687877901.png",
      imageAlt: "Diverse group of professionals collaborating around conference table with laptops and documents in modern office setting",
      level: "Beginner",
      duration: "6 weeks",
      enrolled: 1247,
      modules: 12,
      instructor: "Sarah Johnson",
      instructorAvatar: "https://img.rocket.new/generatedImages/rocket_gen_img_17784c577-1763297418164.png",
      instructorAvatarAlt: "Professional headshot of Caucasian woman with shoulder-length brown hair wearing navy blazer",
      rating: 4.8,
      progress: 0,
      isNew: true
    },
    {
      id: 2,
      title: "Digital Marketing for Social Impact",
      description: "Learn how to create compelling digital campaigns that drive awareness and engagement for nonprofit causes.",
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1339d031a-1764642895849.png",
      imageAlt: "Modern workspace with laptop displaying colorful marketing analytics dashboard and smartphone on wooden desk",
      level: "Intermediate",
      duration: "8 weeks",
      enrolled: 892,
      modules: 16,
      instructor: "Michael Chen",
      instructorAvatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1bd15b436-1763300581767.png",
      instructorAvatarAlt: "Professional headshot of Asian man with short black hair wearing gray suit and glasses",
      rating: 4.9,
      progress: 35,
      isNew: false
    },
    {
      id: 3,
      title: "Grant Writing Mastery",
      description: "Develop the skills to write compelling grant proposals that secure funding for your nonprofit organization.",
      image: "https://images.unsplash.com/photo-1656951096285-61e0add6fe26",
      imageAlt: "Close-up of hands typing on laptop keyboard with coffee cup and notepad on desk in bright office",
      level: "Advanced",
      duration: "10 weeks",
      enrolled: 654,
      modules: 20,
      instructor: "Emily Rodriguez",
      instructorAvatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1975607e9-1763295500639.png",
      instructorAvatarAlt: "Professional headshot of Hispanic woman with long dark hair wearing white blouse and warm smile",
      rating: 4.7,
      progress: 0,
      isNew: false
    },
    {
      id: 4,
      title: "Volunteer Program Management",
      description: "Build and manage successful volunteer programs that engage, retain, and maximize volunteer impact.",
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1c06f8634-1764666124817.png",
      imageAlt: "Group of diverse volunteers wearing matching t-shirts organizing donation boxes in community center",
      level: "Intermediate",
      duration: "7 weeks",
      enrolled: 1089,
      modules: 14,
      instructor: "David Thompson",
      instructorAvatar: "https://img.rocket.new/generatedImages/rocket_gen_img_115ba4024-1763296491756.png",
      instructorAvatarAlt: "Professional headshot of African American man with short hair wearing blue shirt and friendly expression",
      rating: 4.8,
      progress: 60,
      isNew: true
    },
    {
      id: 5,
      title: "Fundraising Strategy & Execution",
      description: "Master proven fundraising techniques and strategies to build sustainable revenue streams for your organization.",
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1ceb05abc-1764672316473.png",
      imageAlt: "Business professionals reviewing financial charts and graphs on tablet in modern conference room",
      level: "Advanced",
      duration: "12 weeks",
      enrolled: 743,
      modules: 24,
      instructor: "Jennifer Lee",
      instructorAvatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1a75d8a4a-1763295501921.png",
      instructorAvatarAlt: "Professional headshot of Asian woman with short black hair wearing red blazer and pearl necklace",
      rating: 4.9,
      progress: 0,
      isNew: false
    },
    {
      id: 6,
      title: "Community Engagement & Outreach",
      description: "Learn effective strategies to build strong community relationships and expand your organization\'s reach.",
      image: "https://images.unsplash.com/photo-1555793320-a91469b81f63",
      imageAlt: "Diverse community members gathered at outdoor event with colorful banners and people engaging in conversation",
      level: "Beginner",
      duration: "5 weeks",
      enrolled: 1456,
      modules: 10,
      instructor: "Marcus Williams",
      instructorAvatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1f4654e97-1763294259256.png",
      instructorAvatarAlt: "Professional headshot of African American man with beard wearing green polo shirt and warm smile",
      rating: 4.6,
      progress: 20,
      isNew: false
    }];


  const skillPaths = [
    {
      id: 1,
      title: "Nonprofit Leadership Track",
      description: "Comprehensive pathway to becoming an effective nonprofit leader",
      category: "Leadership",
      icon: "Users",
      courses: 8,
      totalDuration: "24 weeks",
      skillLevel: "Beginner to Advanced",
      completion: 45
    },
    {
      id: 2,
      title: "Digital Marketing Specialist",
      description: "Master digital marketing strategies for social impact",
      category: "Technical",
      icon: "TrendingUp",
      courses: 6,
      totalDuration: "18 weeks",
      skillLevel: "Intermediate",
      completion: 30
    },
    {
      id: 3,
      title: "Volunteer Coordinator Certification",
      description: "Professional certification for volunteer program management",
      category: "Management",
      icon: "Award",
      courses: 10,
      totalDuration: "30 weeks",
      skillLevel: "All Levels",
      completion: 60
    },
    {
      id: 4,
      title: "Fundraising Professional",
      description: "Complete fundraising strategy and execution pathway",
      category: "Management",
      icon: "DollarSign",
      courses: 12,
      totalDuration: "36 weeks",
      skillLevel: "Advanced",
      completion: 15
    }];


  const achievements = [
    {
      id: 1,
      title: "First Course Complete",
      description: "Completed your first course in the academy",
      icon: "GraduationCap",
      rarity: "Common",
      earned: true,
      progress: 100
    },
    {
      id: 2,
      title: "Quick Learner",
      description: "Completed 5 courses in one month",
      icon: "Zap",
      rarity: "Rare",
      earned: true,
      progress: 100
    },
    {
      id: 3,
      title: "Knowledge Seeker",
      description: "Accessed 50 learning resources",
      icon: "BookOpen",
      rarity: "Common",
      earned: false,
      progress: 72
    },
    {
      id: 4,
      title: "Master Achiever",
      description: "Earned 10 certifications",
      icon: "Trophy",
      rarity: "Epic",
      earned: false,
      progress: 40
    },
    {
      id: 5,
      title: "Community Leader",
      description: "Led 3 study groups to completion",
      icon: "Users",
      rarity: "Rare",
      earned: false,
      progress: 33
    },
    {
      id: 6,
      title: "Perfect Score",
      description: "Achieved 100% on 5 assessments",
      icon: "Target",
      rarity: "Legendary",
      earned: false,
      progress: 20
    }];


  const assessments = [
    {
      id: 1,
      title: "Leadership Skills Assessment",
      description: "Evaluate your leadership capabilities and identify areas for growth",
      icon: "Users",
      questions: 50,
      duration: "45 min",
      difficulty: "Intermediate",
      lastScore: 78,
      lastAttempt: "Dec 10, 2025"
    },
    {
      id: 2,
      title: "Digital Marketing Proficiency",
      description: "Test your knowledge of digital marketing strategies and tools",
      icon: "TrendingUp",
      questions: 40,
      duration: "35 min",
      difficulty: "Advanced",
      lastScore: null,
      lastAttempt: null
    },
    {
      id: 3,
      title: "Grant Writing Fundamentals",
      description: "Assess your grant writing skills and proposal development abilities",
      icon: "FileText",
      questions: 30,
      duration: "30 min",
      difficulty: "Beginner",
      lastScore: 85,
      lastAttempt: "Dec 5, 2025"
    },
    {
      id: 4,
      title: "Volunteer Management Expertise",
      description: "Evaluate your volunteer program management knowledge",
      icon: "Heart",
      questions: 45,
      duration: "40 min",
      difficulty: "Intermediate",
      lastScore: null,
      lastAttempt: null
    }];


  const certifications = [
    {
      id: 1,
      title: "Certified Nonprofit Leader",
      issuer: "VolunteerHub Academy",
      issueDate: "Nov 15, 2025",
      expiryDate: "Nov 15, 2027",
      credentialId: "CNL-2025-1247",
      verified: true
    },
    {
      id: 2,
      title: "Digital Marketing Specialist",
      issuer: "VolunteerHub Academy",
      issueDate: "Oct 22, 2025",
      expiryDate: null,
      credentialId: "DMS-2025-0892",
      verified: true
    },
    {
      id: 3,
      title: "Volunteer Program Manager",
      issuer: "VolunteerHub Academy",
      issueDate: "Sep 8, 2025",
      expiryDate: "Sep 8, 2027",
      credentialId: "VPM-2025-0654",
      verified: true
    }];


  const resources = [
    {
      id: 1,
      title: "Building Effective Volunteer Teams",
      description: "Comprehensive guide to recruiting, training, and retaining quality volunteers",
      type: "PDF",
      duration: "45 min read",
      level: "Intermediate",
      rating: 4.7,
      reviews: 234,
      downloads: "1.2K"
    },
    {
      id: 2,
      title: "Social Media Strategy Workshop",
      description: "Interactive workshop on creating impactful social media campaigns",
      type: "Video",
      duration: "2h 15min",
      level: "Beginner",
      rating: 4.9,
      reviews: 567,
      downloads: null
    },
    {
      id: 3,
      title: "Grant Proposal Template Library",
      description: "Collection of proven grant proposal templates and examples",
      type: "Interactive",
      duration: "30 min",
      level: "All Levels",
      rating: 4.8,
      reviews: 892,
      downloads: "3.4K"
    },
    {
      id: 4,
      title: "Nonprofit Leadership Best Practices",
      description: "In-depth article series on effective nonprofit leadership strategies",
      type: "Article",
      duration: "1h read",
      level: "Advanced",
      rating: 4.6,
      reviews: 156,
      downloads: null
    },
    {
      id: 5,
      title: "Fundraising Skills Quiz",
      description: "Test your fundraising knowledge with this interactive quiz",
      type: "Quiz",
      duration: "20 min",
      level: "Intermediate",
      rating: 4.5,
      reviews: 423,
      downloads: null
    },
    {
      id: 6,
      title: "Community Engagement Toolkit",
      description: "Complete toolkit for building strong community relationships",
      type: "PDF",
      duration: "1h read",
      level: "Beginner",
      rating: 4.8,
      reviews: 678,
      downloads: "2.1K"
    }];


  const studyGroups = [
    {
      id: 1,
      name: "Leadership Development Circle",
      description: "Weekly discussions on nonprofit leadership challenges and solutions",
      memberCount: 24,
      members: [
        {
          avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_18d99fd4b-1763300661484.png",
          avatarAlt: "Professional headshot of woman with blonde hair wearing blue blouse"
        },
        {
          avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_187ac2848-1764684680250.png",
          avatarAlt: "Professional headshot of man with brown hair wearing gray suit"
        },
        {
          avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_16b6d8d69-1763295588171.png",
          avatarAlt: "Professional headshot of woman with dark hair wearing red dress"
        },
        {
          avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1d4884314-1763296936686.png",
          avatarAlt: "Professional headshot of man with black hair wearing white shirt"
        }],

      nextSession: "Dec 18, 2025 at 6:00 PM",
      discussions: 12,
      focus: "Leadership Skills",
      isActive: true,
      joined: true
    },
    {
      id: 2,
      name: "Digital Marketing Innovators",
      description: "Collaborative learning group for digital marketing strategies",
      memberCount: 18,
      members: [
        {
          avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_120f9d597-1763293939407.png",
          avatarAlt: "Professional headshot of woman with red hair wearing green top"
        },
        {
          avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_187ac2848-1764684680250.png",
          avatarAlt: "Professional headshot of man with beard wearing blue shirt"
        },
        {
          avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1c56710a9-1763300346689.png",
          avatarAlt: "Professional headshot of woman with curly hair wearing yellow blouse"
        },
        {
          avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_11ed5f0d4-1763296334836.png",
          avatarAlt: "Professional headshot of man with glasses wearing black jacket"
        }],

      nextSession: "Dec 20, 2025 at 7:00 PM",
      discussions: 8,
      focus: "Digital Marketing",
      isActive: true,
      joined: false
    },
    {
      id: 3,
      name: "Grant Writing Masterminds",
      description: "Peer review and feedback group for grant proposals",
      memberCount: 15,
      members: [
        {
          avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1bcb61d60-1763301235992.png",
          avatarAlt: "Professional headshot of woman with short hair wearing purple sweater"
        },
        {
          avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_19b00e0ce-1763292994800.png",
          avatarAlt: "Professional headshot of man with gray hair wearing navy blazer"
        },
        {
          avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_16b6d8d69-1763295588171.png",
          avatarAlt: "Professional headshot of woman with long hair wearing pink dress"
        },
        {
          avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_187ac2848-1764684680250.png",
          avatarAlt: "Professional headshot of man with mustache wearing brown shirt"
        }],

      nextSession: "Dec 19, 2025 at 5:30 PM",
      discussions: 15,
      focus: "Grant Writing",
      isActive: false,
      joined: false
    }];


  const categoryOptions = [
    { value: 'all', label: 'All Categories' },
    { value: 'leadership', label: 'Leadership' },
    { value: 'technical', label: 'Technical Skills' },
    { value: 'management', label: 'Management' },
    { value: 'communication', label: 'Communication' },
    { value: 'fundraising', label: 'Fundraising' }];


  const levelOptions = [
    { value: 'all', label: 'All Levels' },
    { value: 'beginner', label: 'Beginner' },
    { value: 'intermediate', label: 'Intermediate' },
    { value: 'advanced', label: 'Advanced' }];


  const tabs = [
    { id: 'courses', label: 'Courses', icon: 'BookOpen' },
    { id: 'paths', label: 'Learning Paths', icon: 'Map' },
    { id: 'assessments', label: 'Assessments', icon: 'ClipboardCheck' },
    { id: 'certifications', label: 'Certifications', icon: 'Award' },
    { id: 'resources', label: 'Resources', icon: 'Library' },
    { id: 'community', label: 'Study Groups', icon: 'Users' },
    { id: 'achievements', label: 'Achievements', icon: 'Trophy' }];


  const handleEnrollCourse = (course) => {
    alert(`Enrolled in course: ${course?.title}!\n\nCheck your dashboard for course materials.`);
  };

  const handleViewCourseDetails = (course) => {
    alert(`Viewing details for: ${course?.title}`);
  };

  const handleExplorePath = (path) => {
    alert(`Starting learning path: ${path?.title}`);
  };

  const handleViewBadge = (badge) => {
    alert(`Achievement Unlocked: ${badge?.title}\n\n${badge?.description}`);
  };

  const handleStartAssessment = (assessment) => {
    alert(`Starting assessment: ${assessment?.title}\n\nTime limit: ${assessment?.duration}`);
  };

  const handleViewCertification = (certification) => {
    alert(`Viewing certificate: ${certification?.title}`);
  };

  const handleDownloadCertification = (certification) => {
    alert(`Downloading certificate: ${certification?.title} (PDF)`);
  };

  const handleAccessResource = (resource) => {
    alert(`Opening resource: ${resource?.title}`);
  };

  const handleJoinGroup = (group) => {
    alert(`Joined study group: ${group?.name}`);
  };

  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main className="main-content">
        <div className="bg-gradient-to-br from-primary to-secondary text-white py-16 px-4">
          <div className="max-w-7xl mx-auto">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-12 h-12 rounded-lg bg-white/20 backdrop-blur-sm flex items-center justify-center">
                <Icon name="GraduationCap" size={28} color="white" />
              </div>
              <h1 className="text-4xl md:text-5xl font-bold">Skills Development Academy</h1>
            </div>
            <p className="text-xl text-white/90 max-w-3xl mb-8">
              Transform your volunteer experience into professional growth. Access world-class training, earn certifications, and build skills that create lasting impact.
            </p>

            <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mt-8">
              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6">
                <div className="flex items-center gap-3 mb-2">
                  <Icon name="BookOpen" size={24} color="white" />
                  <span className="text-3xl font-bold">150+</span>
                </div>
                <p className="text-white/80">Courses Available</p>
              </div>
              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6">
                <div className="flex items-center gap-3 mb-2">
                  <Icon name="Award" size={24} color="white" />
                  <span className="text-3xl font-bold">25</span>
                </div>
                <p className="text-white/80">Certifications</p>
              </div>
              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6">
                <div className="flex items-center gap-3 mb-2">
                  <Icon name="Users" size={24} color="white" />
                  <span className="text-3xl font-bold">12K+</span>
                </div>
                <p className="text-white/80">Active Learners</p>
              </div>
              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6">
                <div className="flex items-center gap-3 mb-2">
                  <Icon name="TrendingUp" size={24} color="white" />
                  <span className="text-3xl font-bold">95%</span>
                </div>
                <p className="text-white/80">Completion Rate</p>
              </div>
            </div>
          </div>
        </div>

        <div className="max-w-7xl mx-auto px-4 py-12">
          <div className="bg-card rounded-xl border border-border p-6 mb-8">
            <div className="flex flex-col lg:flex-row gap-4">
              <div className="flex-1">
                <Input
                  type="search"
                  placeholder="Search courses, paths, or resources..."
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e?.target?.value)}
                  className="w-full" />

              </div>
              <div className="flex gap-4">
                <Select
                  options={categoryOptions}
                  value={selectedCategory}
                  onChange={setSelectedCategory}
                  placeholder="Category"
                  className="w-48" />

                <Select
                  options={levelOptions}
                  value={selectedLevel}
                  onChange={setSelectedLevel}
                  placeholder="Level"
                  className="w-48" />

              </div>
            </div>
          </div>

          <div className="mb-8">
            <div className="flex flex-wrap gap-2">
              {tabs?.map((tab) =>
                <button
                  key={tab?.id}
                  onClick={() => setActiveTab(tab?.id)}
                  className={`flex items-center gap-2 px-4 py-2 rounded-lg font-medium transition-all duration-200 ${activeTab === tab?.id ?
                      'bg-primary text-primary-foreground shadow-md' :
                      'bg-muted text-muted-foreground hover:bg-muted/80'}`
                  }>

                  <Icon name={tab?.icon} size={18} />
                  <span>{tab?.label}</span>
                </button>
              )}
            </div>
          </div>

          {activeTab === 'courses' &&
            <div>
              <div className="flex items-center justify-between mb-6">
                <h2 className="text-2xl font-bold text-foreground">Available Courses</h2>
                <span className="text-sm text-muted-foreground">{courses?.length} courses found</span>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {courses?.map((course) =>
                  <CourseCard
                    key={course?.id}
                    course={course}
                    onEnroll={handleEnrollCourse}
                    onViewDetails={handleViewCourseDetails} />

                )}
              </div>
            </div>
          }

          {activeTab === 'paths' &&
            <div>
              <div className="flex items-center justify-between mb-6">
                <h2 className="text-2xl font-bold text-foreground">Learning Paths</h2>
                <span className="text-sm text-muted-foreground">{skillPaths?.length} paths available</span>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                {skillPaths?.map((path) =>
                  <SkillPathCard
                    key={path?.id}
                    path={path}
                    onExplore={handleExplorePath} />

                )}
              </div>
            </div>
          }

          {activeTab === 'assessments' &&
            <div>
              <div className="flex items-center justify-between mb-6">
                <h2 className="text-2xl font-bold text-foreground">Skill Assessments</h2>
                <span className="text-sm text-muted-foreground">{assessments?.length} assessments available</span>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {assessments?.map((assessment) =>
                  <SkillAssessmentCard
                    key={assessment?.id}
                    assessment={assessment}
                    onStart={handleStartAssessment} />

                )}
              </div>
            </div>
          }

          {activeTab === 'certifications' &&
            <div>
              <div className="flex items-center justify-between mb-6">
                <h2 className="text-2xl font-bold text-foreground">My Certifications</h2>
                <span className="text-sm text-muted-foreground">{certifications?.length} earned</span>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {certifications?.map((certification) =>
                  <CertificationCard
                    key={certification?.id}
                    certification={certification}
                    onView={handleViewCertification}
                    onDownload={handleDownloadCertification} />

                )}
              </div>
            </div>
          }

          {activeTab === 'resources' &&
            <div>
              <div className="flex items-center justify-between mb-6">
                <h2 className="text-2xl font-bold text-foreground">Learning Resources</h2>
                <span className="text-sm text-muted-foreground">{resources?.length} resources available</span>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {resources?.map((resource) =>
                  <LearningResourceCard
                    key={resource?.id}
                    resource={resource}
                    onAccess={handleAccessResource} />

                )}
              </div>
            </div>
          }

          {activeTab === 'community' &&
            <div>
              <div className="flex items-center justify-between mb-6">
                <h2 className="text-2xl font-bold text-foreground">Study Groups</h2>
                <span className="text-sm text-muted-foreground">{studyGroups?.length} active groups</span>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {studyGroups?.map((group) =>
                  <StudyGroupCard
                    key={group?.id}
                    group={group}
                    onJoin={handleJoinGroup} />

                )}
              </div>
            </div>
          }

          {activeTab === 'achievements' &&
            <div>
              <div className="flex items-center justify-between mb-6">
                <h2 className="text-2xl font-bold text-foreground">Achievement Badges</h2>
                <span className="text-sm text-muted-foreground">
                  {achievements?.filter((b) => b?.earned)?.length} of {achievements?.length} earned
                </span>
              </div>
              <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-6">
                {achievements?.map((badge) =>
                  <AchievementBadge
                    key={badge?.id}
                    badge={badge}
                    onClick={handleViewBadge} />

                )}
              </div>
            </div>
          }
        </div>

        <div className="bg-muted py-16 px-4 mt-12">
          <div className="max-w-7xl mx-auto text-center">
            <Icon name="Sparkles" size={48} className="mx-auto mb-4 text-primary" />
            <h2 className="text-3xl font-bold text-foreground mb-4">
              Ready to Start Your Learning Journey?
            </h2>
            <p className="text-lg text-muted-foreground mb-8 max-w-2xl mx-auto">
              Join thousands of volunteers who are building skills, earning certifications, and creating meaningful impact through continuous learning.
            </p>
            <Button
              variant="default"
              size="lg"
              iconName="ArrowRight"
              iconPosition="right">

              Browse All Courses
            </Button>
          </div>
        </div>

        <footer className="bg-card border-t border-border py-8 px-4 mt-12">
          <div className="max-w-7xl mx-auto text-center">
            <p className="text-sm text-muted-foreground">
              &copy; {new Date()?.getFullYear()} VolunteerHub. Empowering volunteers through education and skill development.
            </p>
          </div>
        </footer>
      </main>
    </div>);

};

export default SkillsDevelopmentAcademy;